import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawIcon from "./RawChevronLeftIcon.svg.jsx";

const ChevronLeftIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawIcon} {...props} />;
});

export default ChevronLeftIcon;
